"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (target) {
    var category = target.id.replace('selected-', '').replace(/[0-9]+/, '');
    var $modalList = Array.from(document.querySelectorAll(".".concat(category, "__item input")));
    $modalList.forEach(function ($item) {
        if ($item.id === target.id.replace('selected-', ''))
            $item.checked = false;
    });
});
